class Toast {
    constructor(message = '', type = 'success', duration = null) {
        this.container = $('#custom-toast-container');
        this.duration = duration || config.toast_notification_time;

        this.toast = $(`
            <div class="toast toast-${type}">
                <span class="message">${message}</span>
                <span class="close-btn"><i class="fas fa-times"></i></span>
            </div>
        `);

        this.toast.find('.close-btn').on('click', () => {
            this.toast.remove();
        });

        this.container.append(this.toast);

        setTimeout(() => {
            this.toast.remove();
        }, this.duration);
    }
}